module.exports = __webpack_public_path__ + "img/signed.97112a45.png";